/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Repeater`)
};

const es_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto`)
};

const de_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textwiederholer`)
};

const nl_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstherhaler`)
};

const fr_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répéteur de texte`)
};

const it_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetitore di testo`)
};

const pt_br2_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto`)
};

const pt_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de Texto`)
};

const ja_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストリピーター`)
};

const zh_tr_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本重复器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_h1", locale)
	if (locale === "en") return en_tr_h1(inputs)
	if (locale === "es") return es_tr_h1(inputs)
	if (locale === "de") return de_tr_h1(inputs)
	if (locale === "nl") return nl_tr_h1(inputs)
	if (locale === "fr") return fr_tr_h1(inputs)
	if (locale === "it") return it_tr_h1(inputs)
	if (locale === "pt-BR") return pt_br2_tr_h1(inputs)
	if (locale === "pt") return pt_tr_h1(inputs)
	if (locale === "ja") return ja_tr_h1(inputs)
	return zh_tr_h1(inputs)
};